import React from 'react';
import BaseIcon, { IIconProps, getIconDimension } from '../../BaseIcon';
import { getColor } from '../../colors';

const DesktopIconFilled: React.FC<IIconProps> = ({
  size = 'medium',
  width,
  height,
  color = 'currentColor',
  secondaryColor = 'color1',
  ...props
}) => {
  const iconDimension = getIconDimension(size);

  return (
    <BaseIcon
      viewBox="0 0 24 24"
      width={width || iconDimension}
      height={height || iconDimension}
      fill="none"
      color={getColor(color)}
      {...props}
    >
      <rect x="2" y="3" width="21" height="18" fill={getColor(secondaryColor)} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.649994 3.96994C0.649994 2.94821 1.47827 2.11993 2.49999 2.11993H21.65C22.6717 2.11993 23.5 2.94821 23.5 3.96993V20.0301C23.5 21.0518 22.6717 21.8801 21.65 21.8801H2.49999C1.47826 21.8801 0.649994 21.0518 0.649994 20.0301V3.96994ZM2.49999 3.81993C2.41715 3.81993 2.34999 3.88709 2.34999 3.96994V20.0301C2.34999 20.1129 2.41715 20.1801 2.49999 20.1801H21.65C21.7328 20.1801 21.8 20.1129 21.8 20.0301V3.96993C21.8 3.88709 21.7328 3.81993 21.65 3.81993H2.49999Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.582 10.1699H2.18201V8.46994H22.582V10.1699Z"
        fill="currentColor"
      />
      <path
        d="M5.27998 6.20993C5.27998 6.67385 4.90389 7.04993 4.43998 7.04993C3.97606 7.04993 3.59998 6.67385 3.59998 6.20993C3.59998 5.74601 3.97606 5.36993 4.43998 5.36993C4.90389 5.36993 5.27998 5.74601 5.27998 6.20993Z"
        fill="currentColor"
      />
      <path
        d="M8.87995 6.20993C8.87995 6.67385 8.50387 7.04993 8.03995 7.04993C7.57603 7.04993 7.19995 6.67385 7.19995 6.20993C7.19995 5.74601 7.57603 5.36993 8.03995 5.36993C8.50387 5.36993 8.87995 5.74601 8.87995 6.20993Z"
        fill="currentColor"
      />
      <path
        d="M12.48 6.20993C12.48 6.67385 12.104 7.04993 11.64 7.04993C11.1761 7.04993 10.8 6.67385 10.8 6.20993C10.8 5.74601 11.1761 5.36993 11.64 5.36993C12.104 5.36993 12.48 5.74601 12.48 6.20993Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default DesktopIconFilled;
